<template>
  <button @click="$emit('confirm')">
    <slot></slot>
  </button>
</template>
<script>
export default {

};
</script>